import React from 'react';
import { Redirect } from 'react-router-dom';
import { Row, Col, Checkbox } from 'react-bootstrap';
import Moment from 'moment';
import OverviewSearchBar from '../../components/overviewSearchBar/OverviewSearchBar';
import Analytics from '../../components/modules/tudo-azul-analytics';
import CheckoutContainer from '../../components/checkoutContainer/CheckoutContainer';
import I18n from 'i18n-react';
import TaxRules from '../../components/flightSelection/taxRules/TaxRules';
import RefreshTokenCallcenterProvider from '../../components/providers/refreshTokenCallcenter/RefreshTokenCallcenterProvider';

import './CheckoutPage.css';
import CheckoutForm from '../../components/checkoutInfo/checkoutForm/CheckoutForm';
import { isFromCallcenter } from '../../services/queryService/QueryService';
import InfoReloadModal from '../../components/common/bestPriceModal/InfoReloadModal';
import DynamicPanel from '../../components/bookingResume/dynamicPanel/DynamicPanel';
import PaymentInformations from './components/PaymentInformation/PaymentInformations';

const DATE_FORMAT = 'DD/MM/YYYY';
const AMEX = 'amex';

class CheckoutPage extends React.Component {
  constructor() {
    super();

    this.state = {
      termIsChecked: false,
      isModalOpen: false,
      openModalInf: false
    };

    this.alterSearch = this.alterSearch.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
  }

  componentWillMount() {
    if (
      !this.props.location ||
      !this.props.location.state ||
      !this.props.location.state.quotationJourney ||
      !this.props.location.state.flightsFilter ||
      !this.props.location.state.analyticsDataSelect ||
      !this.props.location.state.analyticsDataJourney ||
      !this.props.location.state.passengerInfo ||
      !this.props.location.state.lastFlightDate ||
      !this.props.location.state.analyticsLogin
    ) {
      this.setState({
        isRedirect: true,
        pathname: '/'
      });
    } else {
      this.setState({
        quotationJourney: this.props.location.state.quotationJourney,
        flightsFilter: this.props.location.state.flightsFilter,
        analyticsDataSelect: this.props.location.state.analyticsDataSelect,
        analyticsDataJourney: this.props.location.state.analyticsDataJourney,
        passengerInfo: this.props.location.state.passengerInfo,
        lastFlightDate: this.props.location.state.lastFlightDate,
        analyticsLogin: this.props.location.state.analyticsLogin,
        principalContact: !this.props.location.state.passengerIsChecked,
        sessionId: this.props.location.state.username,
        isCallcenterEnabled: this.props.location.state.isCallcenterEnabled,
        keepLoggedUser: false,
        termIsChecked:
          (this.props.location.state.isCallcenterEnabled && isFromCallcenter()) || false
      });
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.trackingCheckout();
    setTimeout(() => {
         this.setState({ openModalInf: true });     
     }, 900000 )
 
  }

  callCenterMode() {
    return this.state.isCallcenterEnabled && isFromCallcenter();
  }

  toggleModal() {
    this.setState({
      isModalOpen: !this.state.isModalOpen
    });
  }

  proceedTo = (page, response) => {
    this.setState({
      isRedirect: true,
      pathname: page,
      bookingResponse: response
    });
  };

  trackingCheckout() {
    const dataSelect = this.state.analyticsDataSelect;
    const dataJourney = this.state.analyticsDataJourney;
    const analyticsLogin = this.state.analyticsLogin;
    if (dataSelect && dataJourney) {
      const dataPassenger = this.getDataPassenger();
      this.setState({
        analyticsDataPassengers: dataPassenger
      });
      Analytics.trackingCheckout(
        dataSelect,
        dataJourney.dataOrigin,
        dataJourney.dataReturn,
        dataPassenger,
        analyticsLogin
      );
    }
  }

  getDataPassenger() {
    const passengerInfo = this.state.passengerInfo;
    const firstPassenger = passengerInfo[0];

    return {
      name: `${firstPassenger.name} ${firstPassenger.lastName}`,
      gender: firstPassenger.gender.replace('Masculino', 'M').replace('Feminino', 'F'),
      age: Moment().diff(Moment(firstPassenger.age, DATE_FORMAT), 'years'),
      birthdayDate: Moment(firstPassenger.age, DATE_FORMAT).format('YYYY-MM-DD'),
      quantityAdults: this.state.flightsFilter.totalAdults,
      quantityKids: this.state.flightsFilter.totalKids,
      quantityBabys: this.state.flightsFilter.totalBabys
    };
  }

  alterSearch() {
    this.setState({
      isRedirect: true,
      pathname: '/',
      keepLoggedUser: this.callCenterMode()
    });
  }

  validate = () => {
    let isValidForm = true;
    this.cardForm.fields.forEach(field => {
      if (field.props.id === 'cardValidDate') {
        let isMonthValid = field.monthField.validate();
        if (!isMonthValid && isValidForm) {
          field.monthField.input.focus();
          isValidForm = false;
        }
        let isYearValid = field.yearField.validate();
        if (!isYearValid && isValidForm) {
          field.yearField.input.focus();
          isValidForm = false;
        }
        let isDateValid = field.validate();
        if (!isDateValid && isValidForm) {
          field.monthField.input.focus();
          isValidForm = false;
        }
      } else {
        let isFieldValid = field.validate();
        if (!isFieldValid && isValidForm) {
          field.input.focus();
          isValidForm = false;
        }
      }
    });
    return isValidForm;
  };

  isFormValid = () => {
    const { checkoutInfo } = this.state;
    const isPointsPlusMoney = this.isPointsPlusMoney();
    return (
      checkoutInfo &&
      checkoutInfo.cardNumber &&
      checkoutInfo.cardType &&
      checkoutInfo.month &&
      checkoutInfo.year &&
      checkoutInfo.securityCode &&
      checkoutInfo.name &&
      checkoutInfo.cnpjCpf &&
      (!isPointsPlusMoney || checkoutInfo.installment)
    );
  };

  getMaxLengthSecurityCode() {
    let maxLength = 4;
    if (this.state.checkoutInfo && this.state.checkoutInfo.cardType !== AMEX) {
      maxLength = 3;
    }
    return maxLength;
  }

  changeCreditCard = (value, type) => {
    this.setState({
      checkoutInfo: {
        ...this.state.checkoutInfo,
        cardNumber: value,
        cardType: type
      }
    });
  };

  changeValidDate = (month, year) => {
    this.setState({
      checkoutInfo: {
        ...this.state.checkoutInfo,
        month: month,
        year: year
      }
    });
  };

  changeSecurityCode = value => {
    this.setState({
      checkoutInfo: {
        ...this.state.checkoutInfo,
        securityCode: value
      }
    });
  };

  changeName = value => {
    this.setState({
      checkoutInfo: {
        ...this.state.checkoutInfo,
        name: value
      }
    });
  };

  changeCnpjCpf = value => {
    this.setState({
      checkoutInfo: {
        ...this.state.checkoutInfo,
        cnpjCpf: value
      }
    });
  };

  renderModalInfTime() {
    return (
      <InfoReloadModal
        id="modalinf"
        message={I18n.translate('components.checkoutInfo.modalInf.message')}        
        showModal={this.state.openModalInf}           
        firstOption={() => { window.history.go(-2) }} 
        iconTimer={true}       
        ref={c => {
          this.modalinf = c;
        }}
      />
    );
  }

  renderPaymentInfo() {
    return (
      <div className='containerPaymentInformation'>
        <h1 className='titlePaymentInformation'>{I18n.translate('components.quotation.quotationTotalPrice.totalToPay')}</h1>
        <DynamicPanel
          className="componentDynamicPanelInformationPayment"
          title={I18n.translate('resume.paymentData')}>
          <PaymentInformations
            passengers={this.state.passengerInfo}
            departureFlight={this.state.quotationJourney.departureFlight}
            quotationJourney={this.state.quotationJourney}
            returnFlight={this.state.quotationJourney.returnFlight}
            isPointsPlusMoneyDeparture={this.state.quotationJourney.departureFlight.rangePointsPlusMoney ? true : false}
            isPointsPlusMoneyReturn={!this.state.quotationJourney.returnFlight ? false : 
              this.state.quotationJourney.returnFlight.rangePointsPlusMoney ?  true : false}
          />
        </DynamicPanel>
      </div>  
    )
  }

  isPointsPlusMoney() {
    const { departureFlight, returnFlight } = this.state.quotationJourney;
    return (departureFlight && departureFlight.rangePointsPlusMoney) || 
           (returnFlight && returnFlight.rangePointsPlusMoney);
  }

  changeInstallments = value => {
    this.setState({
      checkoutInfo: {
        ...this.state.checkoutInfo,
        installment: value
      }
    });
  }

  shouldShowInstallments = () => {
    return this.isPointsPlusMoney();
  };

  render() {    
    return (
      <div id="pageCheckout">
        <RefreshTokenCallcenterProvider />
        <section className="container-fluid section__outer">
          {this.state.isRedirect ? (
            <Redirect
              push
              to={{
                pathname: this.state.pathname,
                state: this.state,
                search: this.props.location ? this.props.location.search : null
              }}
            />
          ) : (
            <div>
              <Row>
                <Col xs={12}>
                  <OverviewSearchBar
                    origin={this.state.flightsFilter.flightOrigin.code}
                    destination={this.state.flightsFilter.flightDestiny.code}
                    departureDate={this.state.flightsFilter.startDate}
                    returnDate={this.state.flightsFilter.endDate}
                    totalAdults={this.state.flightsFilter.totalAdults}
                    totalKids={this.state.flightsFilter.totalKids}
                    totalBabys={this.state.flightsFilter.totalBabys}
                    alterSearchCallback={this.alterSearch}
                    alterFlightOverviewPrice={false}
                    quotationJourney={this.state.quotationJourney}
                    history={this.props.history}
                    steps={[
                      'components.steps.search',
                      'components.steps.flightSelection',
                      'components.steps.passengers',
                      'components.steps.checkout'
                    ]}
                    stepsBreadcrumb={[
                      'components.steps.search',
                      'components.steps.flightSelection',
                      'components.steps.passengers',
                      'components.steps.checkout'
                    ]}
                    actualStepBreadcrumb="components.steps.checkout"
                    renderOpen={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12} className="CheckoutPage__body">
                  <Row>
                    <Col xs={12} className="CheckoutPage__formTitle collapsedFixedTitle">
                      <span>{I18n.translate('components.checkoutInfo.form.title')}</span>
                    </Col>
                    <Col xs={12} >
                    {this.renderPaymentInfo()}
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} className="CheckoutPage__formSubTitle">
                      <span>{I18n.translate('components.checkoutInfo.form.subTitle')}</span>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} sm={7} md={5} lg={4}>
                      <CheckoutForm
                        id="cardInformation"
                        securityCodeMaxLength={this.getMaxLengthSecurityCode()}
                        changeCreditCard={this.changeCreditCard}
                        changeValidDate={this.changeValidDate}
                        changeSecurityCode={this.changeSecurityCode}
                        changeName={this.changeName}
                        changeCnpjCpf={this.changeCnpjCpf}
                        changeInstallments={this.changeInstallments}
                        showInstallments={this.shouldShowInstallments()}
                        ref={c => {
                          this.cardForm = c;
                        }}
                        sessionId={this.state.sessionId}
                        isCallcenterEnabled={this.state.isCallcenterEnabled}
                        quotationJourney={this.state.quotationJourney}
                        checkoutInfo={this.state.checkoutInfo} 
                      />
                    </Col>
                  </Row>
                  {this.renderCheckBox()}
                  <Row className="CheckoutPage__buttonRow">
                    <Col xs={12} sm={8}>
                      <CheckoutContainer
                        btnDisabled={!this.state.termIsChecked || !this.isFormValid()}
                        location={this.props.location}
                        isFormValid={this.validate}
                        proceedTo={this.proceedTo}
                        {...this.state}
                        ref={c => (this.container = c)}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
              <TaxRules
                id="flightsTax"
                close={this.toggleModal}
                showModal={this.state.isModalOpen}
              />
              {this.renderModalInfTime()}
            </div>
          )}
        </section>
      </div>
    );
  }

  renderCheckBox() {
    if (!this.callCenterMode()) {
      return (
        <Row>
          <Col xs={12} sm={8}>
            <div className={`CheckoutPage__checkbox ${this.state.termIsChecked ? 'checked' : ''}`}>
              <Checkbox
                id="ckBxTerm"
                bsClass={`checkbox CheckoutPage__checkbox--input ${
                  this.state.termIsChecked ? 'checked' : ''
                }`}
                onChange={() => this.setState({ termIsChecked: !this.state.termIsChecked })}
              />
              <label className="CheckoutPage__checkbox--text">
                {I18n.translate('checkout.term1')}
                <a onClick={this.toggleModal}>{I18n.translate('checkout.airTransportContract')}</a>
                {I18n.translate('checkout.term2')}
              </label>
            </div>
          </Col>
        </Row>
      );
    }
  }
}

export default CheckoutPage;



// WEBPACK FOOTER //
// ./src/page/checkout/CheckoutPage.jsx